import { Injectable, OnInit, OnDestroy } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable()

export class PaginatorServices implements OnInit, OnDestroy {

  private pageSubject = new BehaviorSubject({ page: undefined, pages: undefined })
  onUpdatedPage = this.pageSubject.asObservable();

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {}

  setPagination( pagination?: any ):void {

    this.pageSubject.next( pagination );
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/services/paginator.services.ts